import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FurnitureData } from '../../services/furniture';
import { savedService } from '../../services/saved';

const SavedItems: React.FC = () => {
  const [items, setItems] = useState<FurnitureData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    savedService.list().then(setItems).catch(() => setError('Could not load saved items')).finally(() => setLoading(false));
  }, []);

  const remove = async (id: string) => {
    try {
      await savedService.remove(id);
      setItems(current => current.filter(item => item._id !== id));
    } catch {
      setError('Could not remove saved item');
    }
  };

  const clear = async () => {
    try {
      await savedService.clear();
      setItems([]);
    } catch {
      setError('Could not clear saved items');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Saved Items</h1>
            <p className="text-gray-600 mt-2">{items.length} saved</p>
          </div>
          {items.length > 0 && <button onClick={clear} className="px-4 py-2 border border-red-300 text-red-700 rounded-md">Clear All</button>}
        </div>
        {error && <p role="alert" className="text-red-700 mb-4">{error}</p>}
        {loading ? <p>Loading...</p> : items.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-600 mb-4">No saved items</p>
            <Link to="/furniture" className="text-blue-600">Browse Furniture</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map(item => <div key={item._id} className="bg-white rounded-lg shadow overflow-hidden">
              {item.images?.[0] && <img src={item.images[0]} alt={item.title} className="w-full h-48 object-cover" />}
              <div className="p-4">
                <h2 className="text-lg font-medium">{item.title}</h2>
                <p className="text-green-600 font-bold">${item.price}</p>
                <div className="flex justify-between mt-4">
                  <Link to={`/furniture/${item._id}`} className="text-blue-600">View Details</Link>
                  <button onClick={() => remove(item._id)} className="text-red-600" aria-label={`Remove ${item.title}`}>Remove</button>
                </div>
              </div>
            </div>)}
          </div>
        )}
      </div>
    </div>
  );
};

export default SavedItems;
